import styled from "styled-components";
import {JackpotWidgetFooterElementSkeletonBox} from "./jackpot-widget-footer-element-skeleton.box";

export const JackpotWidgetClockLabelSkeletonBox = styled(JackpotWidgetFooterElementSkeletonBox)`
    margin-left: 50%;
`;